import React, { useState, useEffect } from "react";
import {withRouter} from "react-router";
import { Row, Col } from "react-bootstrap";
import "./starRatingTicker.scss";
import ReactStars from "react-rating-stars-component";
import ModalCustom from '../Modal/ModalCustomDesign';
import Star from '../../../assets/star.svg';
import SelectedStar from '../../../assets/selectedStar.svg';
import StarRating from "./StarRating";
import moment from "moment";
import Loader from "../../UI Component/Loader/Loader";

function StarRatingTicker(props) {
    const starRatingDesc = {
        1: 'Very Poor',
        2: 'Poor',
        3: 'Average',
        4: 'Good',
        5: 'Excellent'
    }

    return (
        <>
            <div className={`star_rating_ticker_cont ${props?.tickerAnimate ? "tickerActive" : ""}`}>
                <div className="star_rating_ticker_heading">
                    <span className="close_button" onClick={() => props?.closeTicker()}>
                        <i className="fa fa-close pl-1" aria-hidden="true"></i>
                    </span>
                    <h5>Rate your experience</h5>
                    {props?.checkLastConsultationFeedback?.doctor_name ?
                        <p>{props?.checkLastConsultationFeedback?.doctor_name} <span className="dot_circle"></span> Completed on <span>&nbsp; {moment(props?.checkLastConsultationFeedback.appointment_date).format("MMM DD, YYYY")}</span></p> :
                        <p> <> Patient <span>&nbsp;{props?.checkLastConsultationFeedback?.patient_name} </span> </> <span className="dot_circle"></span> Completed on <span>&nbsp; {moment(props?.checkLastConsultationFeedback.appointment_date).format("MMM DD, YYYY")}</span></p>
                    }
                </div>
                <div className="star-rating-div">
                    {Object.keys(starRatingDesc).map(key => {
                        return (
                            <div className="star-detail" key={key} onClick={() => props.ratingChanged(key)}>
                                <img src={props?.starRating >= key ? SelectedStar : Star} />
                                <div className={`rating-text ${props?.starRating === key ? "star-rating-value" : ""}`}>
                                    {starRatingDesc[key]}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    );
}

export default withRouter(StarRatingTicker);